import withTransformMenuData from "@utils/withTransformMenuData"
import SpecialOpsProductDetails from "@views/SpecialOpsProductDetails"
import { graphql } from "gatsby"
import { compose } from "recompose"

export const query: any = graphql`
  query SpecialOpsProductDetails(
    $productSlug: String
    $customPrintCollectionSlug: String
    $customPrintDesignSlug: String
    $brandSlug: String
  ) {
    contentfulGlobalSettings(internalTitle: { eq: "uag global settings" }) {
      fenixShippingMethods
      prop65Text {
        raw
      }
      countryProhibitedProducts {
        countries
        products {
          slug
        }
        message
      }
    }
    contentfulProduct: contentfulProduct(slug: { eq: $productSlug }) {
      ...SpecialOpsProductDetailsDataFields
    }
    relatedSeries: allContentfulProduct(
      filter: {
        brand: { slug: { eq: $brandSlug } }
        customPrintCollection: { slug: { eq: $customPrintCollectionSlug } }
        customPrintDesign: { slug: { eq: $customPrintDesignSlug } }
      }
    ) {
      nodes {
        ...ProductDataFields
      }
    }
  }
`

export default compose(withTransformMenuData)(SpecialOpsProductDetails) as any
